import RouteHelpers from 'helpers/routes';
import { setExpiredPassword } from 'helpers/expiredPasswordStore';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function usePasswordExpiredRedirect(redirectTo?: string) {
  const navigate = useNavigate();
  const [query] = useSearchParams();

  return function redirectIfExpired(
    error: any,
    email: string,
    password: string
  ) {
    if (!error.password_expired) {
      return false;
    }

    setExpiredPassword(password);

    navigate(RouteHelpers.getPath('users-reset-password'), {
      state: {
        expired: true,
        username: email,
        redirect_to: redirectTo ?? query.get('redirect_to'),
        abs_redirect: query.get('abs_redirect'),
        skip_onboarding: query.get('skip_onboarding') === 'true'
      }
    });

    return true;
  };
}
